import * as firebase from 'firebase/app';

import 'firebase/auth';
import 'firebase/functions';
import 'firebase/database';

const config = {
  apiKey: 'AIzaSyCp37cSL8QReJYSWJVIme8jYtSDS24YeeQ',
  authDomain: 'harmony-coupon-redeem.firebaseapp.com',
  databaseURL: 'https://harmony-coupon-redeem.firebaseio.com',
  projectId: 'harmony-coupon-redeem',
  storageBucket: '',
  messagingSenderId: '130347096539',
  appId: '1:130347096539:web:c4fdf336831b4d68',
};

let app = null;

if (!firebase.apps.length) {
  app = firebase.initializeApp(config);
}

if (process.env.NODE_ENV === 'development') {
  app.functions().useFunctionsEmulator('http://localhost:5000');
}

export { firebase };

export const functions = firebase.functions();
